import { ArrowLeft, Send, HelpCircle } from "lucide-react";
import Button from "../ui/Button";

const ConfirmSubmitModal = ({
  isOpen,
  onConfirm,
  onCancel,
  isSubmitting = false,
  totalQuestions = 0,
  answeredCount = 0,
}) => {
  if (!isOpen) return null;

  const unansweredCount = Math.max(0, totalQuestions - answeredCount);

  return (
    <div className={`modal ${isOpen ? "modal-open" : ""}`}>
      <div className="modal-box max-w-md">
        <div className="text-primary flex justify-center items-center my-4">
          <HelpCircle size={64} className="bg-primary/10 text-primary rounded-full p-3" />
        </div>

        <h3 className="text-center text-xl font-bold mb-2">Submit Quiz?</h3>

        <p className="text-center text-sm opacity-70 mb-4">
          Are you sure you want to submit your quiz? You won&apos;t be able to change your answers after submitting.
        </p>

        {totalQuestions > 0 && (
          <div className="bg-base-200 p-4 rounded-lg mb-6 text-sm space-y-2">
            <div className="flex justify-between">
              <span className="opacity-70">Total Questions:</span>
              <span className="font-semibold">{totalQuestions}</span>
            </div>
            <div className="flex justify-between">
              <span className="opacity-70">Answered:</span>
              <span className="font-semibold text-green-600">{answeredCount}</span>
            </div>
            {unansweredCount > 0 && (
              <div className="flex justify-between">
                <span className="opacity-70">Unanswered:</span>
                <span className="font-semibold text-red-500">{unansweredCount}</span>
              </div>
            )}
          </div>
        )}

        <div className="modal-action grid grid-cols-2 gap-3">
          <button
            type="button"
            className="btn btn-outline border-gray-300"
            onClick={onCancel}
            disabled={isSubmitting}
          >
            <ArrowLeft className="w-4 h-4" /> Continue Quiz
          </button>

          <Button
            className="w-full btn-primary"
            onClick={onConfirm}
            disabled={isSubmitting}
          >
            <Send className="w-4 h-4" /> {isSubmitting ? "Submitting..." : "Yes, Submit"}
          </Button>
        </div>
      </div>

      <form method="dialog" className="modal-backdrop">
        <button onClick={onCancel}>close</button>
      </form>
    </div>
  );
};

export default ConfirmSubmitModal;
